import type { TypedStartListening } from '@reduxjs/toolkit';
import { createListenerMiddleware } from '@reduxjs/toolkit';

import { setEstimateCompletedListener } from './slices/estimate/estimate.listener';
import {
  onResetEventsListener,
  onUpdateEventsListener,
} from './slices/stepper/stepper.listener';

import type { AppDispatch, RootState } from '~/redux/store';

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening;

onResetEventsListener(startAppListening);
onUpdateEventsListener(startAppListening);
setEstimateCompletedListener(startAppListening);
